<template>

  <form v-on:submit="save">

    <div class="card card-info" v-if="state == 'edit'">
      <div class="card-header with-border">
        <h3 class="card-title">Merit Score</h3>
      </div>
      <div class="card-body">
        <div id="studentForm">
          
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Degree *</label>
                  <select required class="form-control" v-model="seldegree">
                    <option value="" selected="selected" disabled="disabled">--Select Degree--</option>
                    <option v-for="item in degrees" v-bind:value="item.DegreeID">{{item.Name}}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>Education Level *</label>
                  <select required class="form-control" v-model="seledu" v-on:change="loadChild()">
                    <option value="" selected="selected" disabled="disabled">--Select Level--</option>
                    <option v-for="item in educationlevels" v-bind:value="item.EducationLevelID">{{item.Name}}</option>
                  </select>
                </div>
              </div>

           
            </div>
            <div class="row" v-show="seledu != ''">
              <div class="col-md-12">
                <label>Score</label>
                <div class="table-responsive">
                  <table id="example2" class="table table-bordered table-color table-sm">
                    <thead class="bg-info text-white">
                      <tr>
                        <th style="width: 5px; text-align: center">Sr.#</th>
                        <th style="width: 20%;">Type</th>
                        <th style="width: 20%;">CGP Score</th>
                        <th style="width: 20%;">Lower Limit</th>
                        <th style="width: 20%;">Upper Limit</th>
                        <th style="width: 20%;">Score</th>
                        <th style="width: 10px;">Status</th>
                        <th style="width: 5px;">Action</th>
                      </tr>
                    </thead>
                    <tbody>

                      <tr v-for="(item, index) in child">
                        <td style="text-align: center">{{index + 1}}</td>
                        <td>
                          <select class="form-control" v-model="item.Type" required>
                            <option value="Semester">Semester</option>
                            <option value="Annual">Annual</option>
                          </select>
                        </td>
                        <td>
                          <select class="form-control" v-if="item.Type == 'Semester'" required v-model="item.CGPScore">
                            <option v-bind:value="4.0">4.0</option>
                            <option v-bind:value="5.0">5.0</option>
                          </select>
                        </td>
                        <td>
                          <input class="form-control" style="text-align:right" required v-model="item.LowerLimit" v-mask="'######'"/>
                        </td>
                        <td>
                          <input class="form-control" required style="text-align:right" v-model="item.UpperLimit" v-mask="'######'"/>
                        </td>
                        <td>
                          <input class="form-control" required style="text-align:right" v-model="item.Score" v-mask="'######'"/>
                        </td>
                        <td style="width: 10%; text-align: center">
                          <input type="checkbox" v-model="item.Active" value="1" />
                        </td>
                        <td style="width: 10%; text-align: center">
                          <i class="fa fa-2x fa-trash" v-on:click="remove(index)"></i>
                        </td>

                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="8">
                          <button type="button" v-on:click="add()" class="btn btn-block btn-dark btn-sm">Add More</button>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
         
        </div>
      </div>
      <div class="card-footer">
        <input type="submit" value="Save" class="btn btn-success float-right" />
        <button type="button" class="btn btn-primary" v-on:click="Back()">Back to List</button>
      </div>
    </div>

    <div class="card card-info" v-if="state == 'default'">
      <div class="card-header with-border">
        <h3 class="card-title" style="width:100%">
           <button  v-on:click="changeState()" type="button" class=" float-left btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
        </h3>
        <button hidden class="btn btn-primary pull-right" v-on:click="changeState()">New</button>
      </div>
      
        <div class="card-body ">
          <div class="table-responsive">
            <table class="table table-bordered table-color table-sm">
              <thead class="bg-info text-white">
                <tr>
                  <th>Degree</th>
                  <th>Education Level</th>
                  <th width="40px">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in record">
                  <td>
                    {{item.Name}}
                  </td>
                  <td>
                    {{item.Edu}}
                  </td>


                  <td hidden align="center"><button style="width: 70px;" v-on:click="edit(item.MeritScoreID)" class="btn btn-primary btn-sm">Edit</button></td>
                  <td> <i class="fa fa-2x fa-edit" v-on:click="edit(item.MeritScoreID)"></i></td>

                </tr>
              </tbody>

            </table>
          </div>
        </div>
     
    </div>


  </form>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        seldegree: '',
        seledu: '',
        seltype: '',
        selcgp: '',
        child: [],
        degrees: [],
        educationlevels: [],
        state: 'default',
        record: []
      }
    },

    created: function () {
      this.pageLoad();
    },
    methods:
    {
      pageLoad() {
        //startReq();
        var vm = this;
        axios.post('/api/AdmissionApi/pageLoadMeritScore')
          .then(function (res) {
            vm.degrees = res.data.deg;
            vm.educationlevels = res.data.edu;
            vm.record = res.data.rec;
            //  endReq();
          })

          .catch(function (res) {
            //endReq();
          });
      },

      loadChild() {
        startReq();
        var vm = this;
        axios.post('/api/AdmissionApi/loadMeritScoreChild', {
          degID: vm.seldegree,
          eduID: vm.seledu
        })
          .then(function (res) {
            vm.child = res.data.q;
            if (vm.child.length > 0) {
              vm.seltype = vm.child[0].Type;
              vm.selcgp = vm.child[0].CGPScore;
            }

            endReq();
          })
          .catch(function (res) {
            endReq();
          });
      },
      save(e) {
        e.preventDefault();
        var vm = this;
        startReq();
        axios.post('/api/AdmissionApi/saveMeritScore?degID=' + vm.seldegree + '&eduID=' + vm.seledu , {
          //cpg: vm.CGPScore,
          Merit: vm.child
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Saved Successfully", "Done");
              vm.clear();
            }
            else
              toastr.error(res.data.msg);

          })
          .catch(function (err) {
            endReq();
            if (err.response) {
              var res = err.response;
              if (res.status == 401) {
                toastr.error(res.data.msg);
              }
              else {
                for (const [key, value] of Object.entries(res.data.errors)) {
                  //console.log(`${value}`);
                  toastr.error(`${value}`);
                }
              }
            }
          })
      },
      Back() {
        //this.state = 'record';
        location.reload();
      },

      edit(id) {
        startReq();
        var vm = this;
        axios.post('/api/AdmissionApi/editMeritScoreChild?id=' + id)
          .then(function (res) {
            vm.child = res.data.q;
            if (vm.child.length > 0) {
              vm.seldegree = vm.child[0].DegreeID;
              vm.seledu = vm.child[0].EducationLevelID;
              vm.seltype = vm.child[0].Type;
              vm.selcgp = vm.child[0].CGPScore;
              vm.state = 'edit';
            }
            endReq();
          })
          .catch(function (res) {
            endReq();
          });
      },

      remove(ind) {
        this.child.splice(ind, 1);
      },

      add() {
        this.child.push({ UpperLimit: '', LowerLimit: '', Score: '', Active: true, Type: '', CGPScore: this.selcgp });
      },

      changeState() {
        this.state = 'edit';
      }
    }

  });
</script>



// WEBPACK FOOTER //
// src/components/onlineadmission/meritScore.vue